import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import axios from 'axios';
import {
    Box,
    Typography,
    Paper,
    Grid,
    Divider,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    TextField,
    Button,
    Container,
    useTheme,
    useMediaQuery,
    styled,
    Avatar,
    Chip,
    CircularProgress,
    Checkbox,
    Select,
    MenuItem,
    InputLabel,
    FormHelperText,
    IconButton
} from '@mui/material';
import swal from 'sweetalert';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ConferenceNavbar from "../../../frontend/Conference/ConferenceNavbar";
import NewVersionAbstractFooter from "../../AbstractAuth/NewVersion/NewVersionAnstractFooter";

// Styled components
const SectionPaper = styled(Paper)(({ theme }) => ({
    marginBottom: theme.spacing(4),
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[3],
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
        boxShadow: theme.shadows[6],
    },
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
    fontWeight: 'bold',
}));

const SubSectionTitle = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(1),
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
    fontSize: '1.1rem',
}));

const QuestionContainer = styled('div')(({ theme }) => ({
    marginBottom: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    borderLeft: `3px solid ${theme.palette.primary.light}`,
}));

const QuestionText = styled(FormLabel)(({ theme }) => ({
    fontWeight: 500,
    marginBottom: theme.spacing(1),
    display: 'block',
}));

const SubmitButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing(3),
    padding: theme.spacing(1.5),
    fontWeight: 'bold',
}));

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const ConferenceEvaluateQuestions = () => {
    const eventid = localStorage.getItem('eventid');
    const belongTo = 12;
    const [customFields, setCustomFields] = useState([]);
    const [groupedFields, setGroupedFields] = useState([]);
    const [loadingFields, setLoadingFields] = useState(true);
    const location = useLocation();
    const history = useHistory();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [participant, setParticipant] = useState(null);
    const [loadingParticipant, setLoadingParticipant] = useState(true);
    const [formData, setFormData] = useState({});
    const [filePreviews, setFilePreviews] = useState({});

    // Organize fields by order and identify section headers
    // const organizeFields = (fields) => {
    //     const organized = [];
    //     const orderGroups = {};

    //     // First, group fields by order
    //     fields.forEach(field => {
    //         const orderKey = field.order_by !== null ? field.order_by : 'ungrouped';

    //         if (!orderGroups[orderKey]) {
    //             orderGroups[orderKey] = [];
    //         }

    //         orderGroups[orderKey].push(field);
    //     });

    //     // Process each order group
    //     Object.keys(orderGroups).forEach(orderKey => {
    //         const group = orderGroups[orderKey];
    //         const section = {
    //             order: orderKey,
    //             title: null,
    //             questions: []
    //         };

    //         // Find if there's a field that should be a section header
    //         // (a field with only name and no type or other data)
    //         group.forEach(field => {
    //             // Check if this field should be a section header
    //             const isHeader = !field.type || field.type === 'header' || 
    //                             (field.name && !field.options && !field.required);

    //             if (isHeader) {
    //                 section.title = field.name;
    //             } else {
    //                 section.questions.push(field);
    //             }
    //         });

    //         // If no header found, use the first question's base name
    //         if (!section.title && section.questions.length > 0) {
    //             const firstQuestion = section.questions[0];
    //             // Extract base name by removing priority indicators
    //             section.title = firstQuestion.name.replace(/\s*-\s*priority\s*\d+$/, '').trim();
    //         }

    //         organized.push(section);
    //     });

    //     return organized;
    // };
    // More granular field type ordering
    // const organizeFields = (fields) => {
    //     const organized = [];
    //     const orderGroups = {};

    //     // Define field type priority (lower number = higher priority)
    //     const fieldTypePriority = {
    //         'radioBox': 1,
    //         'select': 2,
    //         'multiSelect': 3,
    //         'checkBox': 4,
    //         'number': 5,
    //         'image': 6,
    //         'file': 7,
    //         'link': 8,
    //         'textarea': 9,
    //         'input': 10
    //     };

    //     // First, group fields by order
    //     fields.forEach(field => {
    //         const orderKey = field.order_by !== null ? field.order_by : 'ungrouped';

    //         if (!orderGroups[orderKey]) {
    //             orderGroups[orderKey] = [];
    //         }

    //         orderGroups[orderKey].push(field);
    //     });

    //     // Process each order group
    //     Object.keys(orderGroups).forEach(orderKey => {
    //         const group = orderGroups[orderKey];
    //         const section = {
    //             order: orderKey,
    //             title: null,
    //             questions: []
    //         };

    //         // Separate header fields from questions
    //         const headerFields = [];
    //         const questionFields = [];

    //         group.forEach(field => {
    //             // Check if this field should be a section header
    //             const isHeader = !field.type || field.type === 'header' || 
    //                             (field.name && !field.options && !field.required);

    //             if (isHeader) {
    //                 headerFields.push(field);
    //             } else {
    //                 questionFields.push(field);
    //             }
    //         });

    //         // Set section title from header fields
    //         if (headerFields.length > 0) {
    //             section.title = headerFields[0].name;
    //         } else if (questionFields.length > 0) {
    //             // If no header found, use the first question's base name
    //             const firstQuestion = questionFields[0];
    //             section.title = firstQuestion.name.replace(/\s*-\s*priority\s*\d+$/, '').trim();
    //         }

    //         // Sort questions by field type priority
    //         const sortedQuestions = questionFields.sort((a, b) => {
    //             const aPriority = fieldTypePriority[a.type] || 99;
    //             const bPriority = fieldTypePriority[b.type] || 99;

    //             return aPriority - bPriority; // Lower priority number comes first
    //         });

    //         section.questions = sortedQuestions;
    //         organized.push(section);
    //     });

    //     return organized;
    // };
    // Organize fields by order and identify section headers
    const organizeFields = (fields) => {
        const organized = [];
        const orderGroups = {};

        // Function to extract number from field name
        const extractNumberFromName = (name) => {
            if (!name) return null;

            // Match patterns like "1.", "1.1", "2.3.1", etc.
            const match = name.match(/^(\d+(?:\.\d+)*)\./);
            if (match) {
                return match[1];
            }

            // If no number found, return null
            return null;
        };

        // First, group fields by order or by number in name
        fields.forEach(field => {
            let orderKey;

            // First priority: use order_by if available
            if (field.order_by !== null) {
                orderKey = field.order_by.toString();
            }
            // Second priority: extract number from name
            else {
                const numberFromName = extractNumberFromName(field.name);
                orderKey = numberFromName !== null ? numberFromName : 'ungrouped';
            }

            if (!orderGroups[orderKey]) {
                orderGroups[orderKey] = [];
            }

            orderGroups[orderKey].push(field);
        });

        // Process each order group
        Object.keys(orderGroups).forEach(orderKey => {
            const group = orderGroups[orderKey];
            const section = {
                order: orderKey,
                title: null,
                questions: []
            };

            // Separate header fields from questions
            const headerFields = [];
            const questionFields = [];

            group.forEach(field => {
                // Check if this field should be a section header
                const isHeader = !field.type || field.type === 'header' ||
                    (field.name && !field.options && !field.required);

                if (isHeader) {
                    headerFields.push(field);
                } else {
                    questionFields.push(field);
                }
            });

            // Set section title from header fields
            if (headerFields.length > 0) {
                section.title = headerFields[0].name;
            } else if (questionFields.length > 0) {
                // If no header found, use the first question's base name
                const firstQuestion = questionFields[0];
                // Remove the numbering prefix for the section title
                section.title = firstQuestion.name.replace(/^\d+(?:\.\d+)*\.\s*/, '').trim();
            }

            // Sort questions: text inputs (textarea, input) come last
            const sortedQuestions = questionFields.sort((a, b) => {
                const aIsTextInput = a.type === 'textarea' || a.type === 'input';
                const bIsTextInput = b.type === 'textarea' || b.type === 'input';

                if (aIsTextInput && !bIsTextInput) {
                    return 1; // a comes after b
                } else if (!aIsTextInput && bIsTextInput) {
                    return -1; // a comes before b
                } else {
                    // If same type, maintain order based on name numbering
                    const aNumber = extractNumberFromName(a.name);
                    const bNumber = extractNumberFromName(b.name);

                    if (aNumber && bNumber) {
                        return aNumber.localeCompare(bNumber, undefined, { numeric: true });
                    }
                    return 0;
                }
            });

            section.questions = sortedQuestions;
            organized.push(section);
        });

        // Sort sections by order (handle dot notation for sub-numbers)
        return organized.sort((a, b) => {
            if (a.order === 'ungrouped') return 1; // ungrouped goes last
            if (b.order === 'ungrouped') return -1; // ungrouped goes last

            // Handle dot notation for proper numerical sorting (1.1, 1.2, 2.1, etc.)
            const partsA = a.order.split('.').map(part => parseInt(part));
            const partsB = b.order.split('.').map(part => parseInt(part));

            // Compare each part of the number
            const maxLength = Math.max(partsA.length, partsB.length);
            for (let i = 0; i < maxLength; i++) {
                const partA = partsA[i] || 0;
                const partB = partsB[i] || 0;

                if (partA !== partB) {
                    return partA - partB;
                }
            }

            return 0;
        });
    };

    // Load custom fields from API
    useEffect(() => {
        axios.get(`api/load-customfield-evaluations/${belongTo}/${eventid}`)
            .then(res => {
                if (res.status === 200) {
                    const fields = res.data.customFieldLoad || [];
                    setCustomFields(fields);

                    // Organize fields by order and identify section headers
                    const organized = organizeFields(fields);
                    setGroupedFields(organized);

                    // Initialize form data structure
                    const initialFormData = {};
                    fields.forEach(field => {
                        // Skip header fields in form data
                        const isHeader = !field.type || field.type === 'header' ||
                            (field.name && !field.options && !field.required);

                        if (!isHeader) {
                            if (field.type === 'multiSelect' || field.type === 'checkBox') {
                                initialFormData[field.id] = [];
                            } else {
                                initialFormData[field.id] = '';
                            }
                        }
                    });
                    setFormData(initialFormData);
                } else {
                    swal('Error', "Failed to load evaluation questions", 'error');
                }
            })
            .catch(error => {
                swal('Error', "Failed to load evaluation questions", 'error');
                console.error('Error loading custom fields:', error);
            })
            .finally(() => setLoadingFields(false));
    }, [eventid]);

    // Load participant data
    useEffect(() => {
        const locationParticipant = location.state?.participant;
        const storedParticipant = localStorage.getItem('conferenceParticipant');

        if (locationParticipant) {
            setParticipant(locationParticipant);
            localStorage.setItem('conferenceParticipant', JSON.stringify(locationParticipant));
        } else if (storedParticipant) {
            setParticipant(JSON.parse(storedParticipant));
        }
        setLoadingParticipant(false);

        return () => {
            localStorage.removeItem('conferenceParticipant');
        };
    }, [location.state]);

    const handleInputChange = (fieldId, value) => {
        setFormData(prev => ({
            ...prev,
            [fieldId]: value
        }));
    };

    const handleCheckboxChange = (fieldId, optionValue, isChecked) => {
        setFormData(prev => {
            const currentValues = prev[fieldId] || [];
            if (isChecked) {
                return {
                    ...prev,
                    [fieldId]: [...currentValues, optionValue]
                };
            } else {
                return {
                    ...prev,
                    [fieldId]: currentValues.filter(item => item !== optionValue)
                };
            }
        });
    };

    const handleFileChange = (fieldId, event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Create preview for images
        if (file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFilePreviews(prev => ({
                    ...prev,
                    [fieldId]: reader.result
                }));
            };
            reader.readAsDataURL(file);
        }

        // Store the file in form data
        setFormData(prev => ({
            ...prev,
            [fieldId]: file
        }));
    };

    //   const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     const participantId = participant?.id;
    //     const formDataToSubmit = new FormData();
    //     formDataToSubmit.append('participant_id', participant?.id);
    //     formDataToSubmit.append('event_id', eventid);

    //     // Append all form responses using field IDs for proper order mapping
    //     Object.entries(formData).forEach(([fieldId, value]) => {
    //         const field = customFields.find(f => f.id == fieldId);
    //         const fieldName = field?.name || fieldId;

    //         if (value instanceof File) {
    //             formDataToSubmit.append(`responses[${fieldName}]`, value);
    //         } else if (Array.isArray(value)) {
    //             formDataToSubmit.append(`responses[${fieldName}]`, JSON.stringify(value));
    //         } else {
    //             formDataToSubmit.append(`responses[${fieldName}]`, value);
    //         }
    //     });

    //     try {
    //         const response = await axios.post('api/submit-evaluation', formDataToSubmit, {
    //             headers: {
    //                 'Content-Type': 'multipart/form-data'
    //             }
    //         });

    //         if (response.status === 200) {
    //             const certificateUrl = response.data.certificate_link;

    //             swal({
    //                 icon: 'success',
    //                 title: 'Submitted!',
    //                 text: 'Your evaluation has been submitted successfully.',
    //                 confirmButtonColor: '#3085d6',
    //             }).then(() => {
    //                 history.push({
    //                     pathname: `/conference/evaluation-thank-you`,
    //                     state: { certificateUrl, participantId }
    //                 });
    //             });
    //         }
    //     } catch (error) {
    //         swal({
    //             icon: 'error',
    //             title: 'Error',
    //             text: error?.response?.data?.message || 'Something went wrong while submitting the evaluation.',
    //             confirmButtonColor: '#d33',
    //         });
    //     }
    // };

    const [submitting, setSubmitting] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        const participantId = participant?.id;
        const formDataToSubmit = new FormData();
        formDataToSubmit.append('participant_id', participant?.id);
        formDataToSubmit.append('event_id', eventid);

        // Append all form responses using field IDs for proper order mapping
        Object.entries(formData).forEach(([fieldId, value]) => {
            const field = customFields.find(f => f.id == fieldId);
            const fieldName = field?.name || fieldId;

            if (value instanceof File) {
                formDataToSubmit.append(`responses[${fieldName}]`, value);
            } else if (Array.isArray(value)) {
                formDataToSubmit.append(`responses[${fieldName}]`, JSON.stringify(value));
            } else {
                formDataToSubmit.append(`responses[${fieldName}]`, value);
            }
        });

        try {
            const response = await axios.post('api/submit-evaluation', formDataToSubmit, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.status === 200) {
                const certificateUrl = response.data.certificate_link;

                // Show success message but redirect immediately without waiting for user to click OK
                swal({
                    icon: 'success',
                    title: 'Submitted!',
                    text: 'Your evaluation has been submitted successfully.',
                    confirmButtonColor: '#3085d6',
                    timer: 1500, // Auto close after 1.5 seconds
                    buttons: false // Remove the OK button
                });

                // Redirect immediately after successful submission
                setTimeout(() => {
                    history.push({
                        pathname: `/conference/evaluation-thank-you`,
                        state: { certificateUrl, participantId }
                    });
                }, 1000); // Redirect after 1 second (shorter than the timer)

            }
        } catch (error) {
            setSubmitting(false);
            swal({
                icon: 'error',
                title: 'Error',
                text: error?.response?.data?.message || 'Something went wrong while submitting the evaluation.',
                confirmButtonColor: '#d33',
            });
        }
    };



    const handleReturn = () => {
        history.push('/conference/evaluation');
    };

    const renderField = (field) => {
        switch (field.type) {
            case 'radioBox':
                return (
                    <RadioGroup
                        row={!isMobile}
                        value={formData[field.id] || ''}
                        onChange={(e) => handleInputChange(field.id, e.target.value)}
                    >
                        {field.options.map((option, index) => (
                            option.name && (
                                <FormControlLabel
                                    key={index}
                                    value={option.name}
                                    control={<Radio color="primary" required />}
                                    label={option.name}
                                    labelPlacement={isMobile ? 'bottom' : 'end'}
                                />
                            )
                        ))}
                    </RadioGroup>
                );

            case 'textarea':
                return (
                    <TextField
                        multiline
                        rows={4}
                        variant="outlined"
                        fullWidth
                        placeholder={`Enter your ${field.name.toLowerCase()} here...`}
                        value={formData[field.id] || ''}
                        onChange={(e) => handleInputChange(field.id, e.target.value)}
                    />
                );

            case 'input':
                return (
                    <TextField
                        variant="outlined"
                        fullWidth
                        placeholder={`Enter your ${field.name.toLowerCase()} here...`}
                        value={formData[field.id] || ''}
                        onChange={(e) => handleInputChange(field.id, e.target.value)}
                    />
                );

            case 'select':
                return (
                    <FormControl fullWidth variant="outlined">
                        <Select
                            value={formData[field.id] || ''}
                            onChange={(e) => handleInputChange(field.id, e.target.value)}
                            displayEmpty
                        >
                            <MenuItem value="" disabled>
                                Select an option
                            </MenuItem>
                            {field.options.map((option, index) => (
                                option.name && (
                                    <MenuItem key={index} value={option.name}>
                                        {option.name}
                                    </MenuItem>
                                )
                            ))}
                        </Select>
                    </FormControl>
                );

            case 'multiSelect':
                return (
                    <FormControl fullWidth variant="outlined">
                        <Select
                            multiple
                            value={formData[field.id] || []}
                            onChange={(e) => handleInputChange(field.id, e.target.value)}
                            renderValue={(selected) => selected.join(', ')}
                        >
                            {field.options.map((option, index) => (
                                option.name && (
                                    <MenuItem key={index} value={option.name}>
                                        <Checkbox checked={formData[field.id]?.includes(option.name) || false} />
                                        {option.name}
                                    </MenuItem>
                                )
                            ))}
                        </Select>
                    </FormControl>
                );

            case 'checkBox':
                return (
                    <FormControl component="fieldset" fullWidth>
                        {field.options.map((option, index) => (
                            option.name && (
                                <FormControlLabel
                                    key={index}
                                    control={
                                        <Checkbox
                                            checked={formData[field.id]?.includes(option.name) || false}
                                            onChange={(e) => handleCheckboxChange(field.id, option.name, e.target.checked)}
                                            color="primary"
                                        />
                                    }
                                    label={option.name}
                                />
                            )
                        ))}
                    </FormControl>
                );

            case 'number':
                return (
                    <TextField
                        type="number"
                        variant="outlined"
                        fullWidth
                        placeholder={`Enter your ${field.name.toLowerCase()} here...`}
                        value={formData[field.id] || ''}
                        onChange={(e) => handleInputChange(field.id, e.target.value)}
                        InputProps={{ inputProps: { min: 0 } }}
                    />
                );

            case 'image':
                return (
                    <Box>
                        <Button
                            component="label"
                            variant="contained"
                            startIcon={<CloudUploadIcon />}
                        >
                            Upload Image
                            <VisuallyHiddenInput
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleFileChange(field.id, e)}
                            />
                        </Button>
                        {filePreviews[field.id] && (
                            <Box mt={2}>
                                <img
                                    src={filePreviews[field.id]}
                                    alt="Preview"
                                    style={{ maxWidth: '100%', maxHeight: '200px' }}
                                />
                            </Box>
                        )}
                    </Box>
                );

            case 'file':
                return (
                    <Button
                        component="label"
                        variant="contained"
                        startIcon={<CloudUploadIcon />}
                        fullWidth
                    >
                        Upload File
                        <VisuallyHiddenInput
                            type="file"
                            onChange={(e) => handleFileChange(field.id, e)}
                        />
                    </Button>
                );

            case 'link':
                return (
                    <TextField
                        type="url"
                        variant="outlined"
                        fullWidth
                        placeholder={`Enter your ${field.name.toLowerCase()} here...`}
                        value={formData[field.id] || ''}
                        onChange={(e) => handleInputChange(field.id, e.target.value)}
                    />
                );

            default:
                return null; // Don't render anything for header fields
        }
    };

    if (loadingParticipant || loadingFields) {
        return (
            <Container maxWidth="md" sx={{ py: 3, display: 'flex', justifyContent: 'center' }}>
                <CircularProgress />
            </Container>
        );
    }

    if (!participant) {
        return (
            <Container maxWidth="md" sx={{ py: 3, textAlign: 'center' }}>
                <Typography variant="h6" color="error">
                    Participant information not found
                </Typography>
                <Button
                    variant="outlined"
                    sx={{ mt: 2 }}
                    onClick={handleReturn}
                >
                    Return to Conference Page
                </Button>
            </Container>
        );
    }

    return (
        <div>
            <Grid item xs={12} sm={10} md={8} lg={6}>
                <ConferenceNavbar />
            </Grid>

            <Container maxWidth="md" sx={{ py: 3 }}>
                <Typography variant="h4" gutterBottom align="center" color="primary">
                    Conference Evaluation
                </Typography>

                {/* Participant Information Section */}
                <Paper sx={{
                    p: 3,
                    mb: 4,
                    backgroundColor: theme.palette.grey[100],
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: 'center',
                    gap: 3
                }}>
                    <Avatar
                        sx={{ width: 80, height: 80, fontSize: 32 }}
                        alt={participant.participant_name || 'Participant'}
                    >
                        {(participant.participant_name || 'P').charAt(0)}
                    </Avatar>

                    <Box sx={{ flex: 1 }}>
                        <Typography variant="h6" component="div">
                            {participant.name_title} {participant.participant_name}
                        </Typography>

                        <Grid container spacing={2} sx={{ mt: 1 }}>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2">
                                    <strong>Email:</strong> {participant.participant_email}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2">
                                    <strong>Phone:</strong> {participant.participant_phone_number}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2">
                                    <strong>Profession:</strong> {participant.participant_profession}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2">
                                    <strong>Country:</strong> {participant.participant_country}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2">
                                    <strong>City:</strong> {participant.participant_city}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                    <Chip
                                        label={`ID: ${participant.id}`}
                                        size="small"
                                        color="primary"
                                        variant="outlined"
                                    />
                                    {participant.participant_saudi_council_no && (
                                        <Chip
                                            label={`Council No: ${participant.participant_saudi_council_no}`}
                                            size="small"
                                        />
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
                {customFields.length === 0 ? (
                    <Typography variant="body2" color="textSecondary" align="center" mt={2}>
                        No evaluation questions available at this time.
                    </Typography>
                ) : (
                    <Typography variant="subtitle1" gutterBottom align="center" paragraph>
                        Please take a few minutes to provide feedback about your conference experience.
                    </Typography>
                )}

                <form onSubmit={handleSubmit}>
                    {groupedFields.map((section, index) => (
                        <SectionPaper key={index}>
                            <SectionTitle variant="h5">
                                {section.title}
                            </SectionTitle>
                            <Divider sx={{ mb: 3 }} />

                            {section.questions.map((field) => (
                                <QuestionContainer key={field.id}>
                                    <FormControl component="fieldset" fullWidth>
                                        <QuestionText component="legend">
                                            {field.name}
                                        </QuestionText>
                                        {renderField(field)}
                                    </FormControl>
                                </QuestionContainer>
                            ))}
                        </SectionPaper>
                    ))}

                    <Box display="flex" justifyContent="center" mt={4}>
                        <SubmitButton
                            type="submit"
                            variant="contained"
                            color="primary"
                            size="large"
                            disabled={customFields.length === 0 || submitting}
                        >
                            {submitting ? <CircularProgress size={24} /> : 'Submit Evaluation'}
                        </SubmitButton>
                    </Box>
                </form>
            </Container>

            <Grid item xs={12} sm={10} md={8} lg={6} marginTop="40px">
                <NewVersionAbstractFooter />
            </Grid>
        </div>
    );
};

export default ConferenceEvaluateQuestions;    